// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nameCol {
    cursor: pointer;
}

.nameCol:hover {
    background-color: #f8f9fa;
}

tbody tr:hover {
    background-color: #f8f9fa;
}

.tableOutline {
    border: 1px solid #eeeeee;
    border-radius: 5px;
    margin-top: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Blog/BlogList/BlogList.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB","sourcesContent":[".nameCol {\n    cursor: pointer;\n}\n\n.nameCol:hover {\n    background-color: #f8f9fa;\n}\n\ntbody tr:hover {\n    background-color: #f8f9fa;\n}\n\n.tableOutline {\n    border: 1px solid #eeeeee;\n    border-radius: 5px;\n    margin-top: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
